import templatesFront from '../front/_index';

const main = () => {
    templatesFront();
}

export default main;
